var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatTimeRange } from '@web/components/ui/charts/SimpleBarTimeline';
import { formatDuration } from '@workalizer/shared/utils';
import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
var multiHeaderKey = 'app.performanceReview.employeePerformanceReview.communicationSection.employeeMeetingsByTimePeriodMultiHeader';
function formatMeetingTooltipDate(isoDate) {
    return format(parseISO(isoDate), 'EEE, MMM d', { locale: enUS });
}
function buildMeetingTooltipLine(m) {
    var _a;
    var clockRange = formatTimeRange(m.startTime, m.endTime);
    var durationLabel = formatDuration(m.durationMinutes * 60, 'seconds');
    var clockAndDuration = "".concat(clockRange, " (").concat(durationLabel, ")");
    var dateLabel = formatMeetingTooltipDate(m.date);
    var title = (_a = m.title) === null || _a === void 0 ? void 0 : _a.trim();
    if (title) {
        return "".concat(dateLabel, " - ").concat(title, " - ").concat(clockAndDuration);
    }
    return "".concat(dateLabel, " ").concat(clockAndDuration);
}
export function MeetingsByTimePeriodTooltip(_a) {
    var _b;
    var item = _a.item;
    var t = useTranslation().t;
    var meetings = (_b = item.meetings) !== null && _b !== void 0 ? _b : [];
    if (meetings.length === 0) {
        return (_jsx("p", { children: "".concat(item.count, " ").concat(item.count === 1 ? t('meeting') : t('meetings'), ": ").concat(formatTimeRange(item.startTime, item.endTime)) }));
    }
    if (meetings.length === 1) {
        return _jsx("p", { children: buildMeetingTooltipLine(meetings[0]) });
    }
    return (_jsxs("div", __assign({ className: "flex flex-col gap-1" }, { children: [_jsx("p", { children: t(multiHeaderKey, { count: meetings.length }) }), _jsx("ul", __assign({ className: "list-disc space-y-0.5 pl-4 text-left marker:text-gray-500" }, { children: meetings.map(function (m) { return (_jsx("li", { children: buildMeetingTooltipLine(m) }, "".concat(m.meetingId, "-").concat(m.date, "-").concat(m.startTime))); }) }))] })));
}
